"use strict";

/**
 * Mirror of `aero-ui/packages/website/src/cross-app/events.ts`.
 *
 * All `CustomEvent`s exchanged between aero-ui (when embedded) and
 * provider-portal flow through these helpers. Keep the event names in sync
 * with the aero-ui file when adding or removing events; detail shapes are
 * documented there.
 */

const CrossAppEvent = Object.freeze({
  CORE_READY: "core-ready",
  CLINICAL_NAVIGATE: "clinical:navigate",
  CLINICAL_BADGE_COUNTS: "clinical:badge-counts",
});

function dispatchCrossAppEvent(name, detail) {
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

function onCrossAppEvent(name, handler) {
  const listener = (e) => handler(e.detail);
  window.addEventListener(name, listener);
  return () => window.removeEventListener(name, listener);
}

module.exports = { CrossAppEvent, dispatchCrossAppEvent, onCrossAppEvent };
